import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { borderRadius, breakpoints, colors, screenSizes, spacing } =
    useTheme();

  return {
    base: isTeamCard => css`
      margin-bottom: 1.5rem;

      ${isTeamCard &&
      css`
        margin-bottom: 0;
      `}
    `,
    title: css`
      border-bottom: 1px solid ${colors.greyShade1};
      color: ${colors.navy};
      background-color: ${colors.lightGrey};
      cursor: pointer;
      font-size: 1rem;
      margin: 0;
      display: flex;
      align-items: center;
      line-height: normal;
      justify-content: space-between;
      padding: 12px 16px;
      &:hover {
        box-shadow: 0px 0px 0px 1px #bbc1ce inset;
      }

      ${breakpoints.l} {
        font-size: 1rem;
      }
    `,
    list: expandAnimation => css`
      display: grid;
      grid-gap: ${spacing.s};

      ${expandAnimation === true &&
      css`
        height: 194px;
        animation-name: opacitytest;
        animation-duration: 1s;
        margin: auto;
        display: grid;
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;

        @keyframes opacitytest {
          50% {
            transition-property: opacity;
            transition: 0.5s;
            transition-timing-function: ease-in-out;

            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
      `}
    `,
    buttonWrapper: isTeamCard => css`
      margin-top: ${spacing.m};
      ${isTeamCard &&
      css`
        background-color: ${colors.blue};
      `}

      ${breakpoints.m} {
        border-top: 1px solid ${colors.lightGrey};
        border-bottom: 1px solid ${colors.lightGrey};
      }
    `,
    button: isTeamCard => css`
      display: flex;
      align-items: center;
      margin: 0 auto;
      font-weight: normal;
      text-transform: uppercase;
      text-decoration: none;

      ${isTeamCard &&
      css`
        background-color: ${colors.blue};
        color: ${colors.white};
      `}

      @media screen and (max-width: ${screenSizes.m}) {
        background-color: ${colors.blue};
        color: ${colors.white};
        font-size: 0.875rem;
        letter-spacing: 0.01em;
        // border-radius: ${borderRadius.s};
        width: 100%;
        max-width: 300px;
        display: block;
        padding: 0.9375rem 1.5rem;
      }
    `,
    buttonIcon: (isExpanded, isTeamCard) => css`
      transform: rotate(90deg);
      > g {
        fill: ${isTeamCard ? colors.blue : colors.white};
      }

      ${isExpanded &&
      css`
        transform: rotate(-90deg);
      `}

      @media screen and (max-width: ${screenSizes.m}) {
        display: none;
      }
    `,
    accordionBody: css`
      padding: 16px;
    `,
    accordionButtonDown: css`
      ${breakpoints.s} {
        &:focus-visible {
          outline: 2px solid ${colors.skip_yellow};
          border: 2px solid ${colors.border_black};
          border-radius: 50%;
        }
        &:focus-visible circle {
          stroke: ${colors.next_grey} !important;
        }
        &:focus-visible g path{
          fill: ${colors.next_grey} !important;
        }
      }
    }
  `,
    accordionButtonUp: css`
        &:focus-visible {
          outline: 2px solid ${colors.skip_yellow};
          border: 2px solid ${colors.border_black};
          border-radius: 50%;
        }
        &:focus-visible > path {
          stroke: ${colors.next_grey} !important;
        }
        &:focus-visible svg > g > path {
          fill: ${colors.white} !important;
        }
      }
    }
  `,
  };
};